import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  label: {
    width: 60,
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.text.disabled,
    marginRight: theme.spacing(1),
    textAlign: "left"
  },
  required: {
    color: theme.palette.extras.red,
    marginLeft: theme.spacing(0.5),
    height: "100%"
  }
}));
